// mql(matchMediaQuery)
import { mql } from "./module/mql";

import responsiveVideo from "./module/responsiveVideo";

//microModal
import MicroModal from "micromodal";

(() => {
    document.addEventListener("DOMContentLoaded", () => {
        //MicroModal
        MicroModal.init({
            disableScroll: true,
        });

        //画面幅の監視
        mql.onchange = (e) => {
            if (e.matches) {
                /* ビューポートが 768 ピクセル幅以下 */
                responsiveVideo(e.matches);
            } else {
                /* ビューポートが 768 ピクセル幅より広い */
                responsiveVideo(e.matches);
            }
        };

        //閲覧時に、ビューポートが768px以下だったとき
        if (mql.matches) {
            responsiveVideo(mql.matches);
        }

        //splide
        const splide = new Splide(".splide", {
            drag: "free",
            snap: true,
            perPage: 5,
            perMove: 1,
            focus: "center",
            gap: "30px",
            type: "loop",
            autoplay: true,
            interval: 3000,
            breakpoints: {
                820: {
                    perPage: 4,
                    gap: "15px",
                },
                414: {
                    perPage: 2,
                    gap: "10px",
                },
            },
        });
        splide.mount();
    });
})();
